import React, { useState, useEffect } from "react";

const centerLoader = {
  paddingLeft: "50%",
  paddingTop: "45px",
};

function ReportFrame(props) {
  const url = "https://report.dev.audiencemaker.com/Link/";
  const { shortlink, token } = props;
  const finalLink = `${url}?shortLink=${shortlink}&logonTokenId=${token}`;

  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    setShowLoader(true);
    setTimeout(() => {
      setShowLoader(false);
    }, 4000);
  }, []);

  return (
    <>
      <div className="report-wrapper">
        {showLoader ? (
          <div style={centerLoader}>
            <div className="loader" />
          </div>
        ) : (
          <iframe
            className="dundas-bi-embed embed"
            src={finalLink}
            title="report"
          ></iframe>
        )}
      </div>
    </>
  );
}

export default ReportFrame;
